module.exports = __webpack_public_path__ + "static/media/uisce.bad50eef.png";